import React, { useEffect } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate
} from "react-router-dom";
import Cabinet from "../../../pages/Cabinet/Cabinet";
import Error from "../../../pages/Error/Error";
import Home from "../../../pages/Home/Home";
import SongbookPage from "../../../pages/Songbook/Songbook";
import LoginModal from "../dynamic/LoginModal/LoginModal";
import Manual from "../../widgets/Manual/Manual";
import PrivacyUkr from "../../widgets/PrivacyPolicy/PrivacyUkr";
import { Auth } from "../../../@core/auth";
import "./Content.scss";

const Content = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const lastUrl = localStorage.getItem("lastVisitedUrl");
    if (lastUrl && lastUrl !== "/" && window.location.pathname === "/") {
      navigate(lastUrl);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("lastVisitedUrl", location.pathname);
  }, [location.pathname]);

  return (
    <section>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/cabinet"
          element={Auth.isAuthenticated ? <Cabinet /> : <LoginModal />}
        />
        <Route path="/songbook/:songbookId" element={<SongbookPage />} />
        <Route
          path="/songbook/:songbookId/song/:songId"
          element={<SongbookPage />}
        />
        <Route path="/error" element={<Error />} />
        <Route path="/loginmodal" element={<LoginModal />} />
        <Route path="/manual" element={<Manual />} />
        <Route path="/privacypolicyukr" element={<PrivacyUkr />} />

        <Route path="*" element={<Navigate replace to="/error" />} />
      </Routes>
    </section>
  );
};

export default Content;
